import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "silencetab-dropdown" }
const _hoisted_2 = { class: "applybtn-tooltip" }

import { ref, computed, watchEffect } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { VoicesMutationTypes as VoicesMutationType } from '@/store/voices/mutations'
import { addTagsToSelection } from '@/utils/addTagsToSelection'
import Dropdown from '@/components/UI/DropDown.vue'
import Button from './UI/Button.vue'
import CustomTooltip from '@/components/UI/CustomToolTip.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'SilenceTab',
  props: {
  disableSilenceApply: {
    type: Boolean
  }
},
  setup(__props) {


const store = useStore()
const { t } = useI18n()

const disableApplyButton = ref(true)
const values = ref([
  { value: '0ms', label: '0ms', selected: '250ms' },
  { value: '100ms', label: '100ms', selected: '250ms' },
  { value: '250ms', label: '250ms', selected: '250ms' },
  { value: '500ms', label: '500ms', selected: '250ms' },
  { value: '1s', label: '1s', selected: '250ms' },
  { value: '2s', label: '2s', selected: '250ms' },
  { value: '3s', label: '3s', selected: '250ms' },
  { value: '4s', label: '4s', selected: '250ms' },
  { value: '5s', label: '5s', selected: '250ms' }
])
const silenceValue = ref('250ms')
const showTooltip = ref(false)
const silenceStore = computed(() => store.state.voices.voiceSilenceValue)

const onSilenceChange = (e) => {
  silenceValue.value = e.target.value
}
const applyEffects = () => {
  const selection = document.getSelection()

  if (selection.isCollapsed == true && silenceValue.value != '0ms') {
    store.commit(VoicesMutationType.SET_VOICE_SILENCE_VALUE, silenceValue.value)
    values.value.map((value) => (value.selected = silenceValue.value))
  }
  const tagClass = 'silence'
  addTagsToSelection(selection, silenceValue.value, '0ms', silenceValue.value, tagClass, t, 'CRUD')
}

watchEffect(() => {
  silenceStore.value
  if (silenceStore.value == '') {
    values.value.map((value) => (value.selected = '250ms'))
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Dropdown, {
      items: values.value,
      selectType: "silenceSelect",
      onChange: _cache[0] || (_cache[0] = ($event: any) => (onSilenceChange($event)))
    }, null, 8, ["items"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "applybutton",
        onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (showTooltip.value = true)),
        onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (showTooltip.value = false))
      }, [
        _createVNode(Button, {
          text: _ctx.$t('_buttons.apply'),
          buttonType: "silence-tab-apply",
          "is-disabled": silenceValue.value != '0ms' ? __props.disableSilenceApply : true,
          onClick: applyEffects
        }, null, 8, ["text", "is-disabled"])
      ], 32),
      _createVNode(CustomTooltip, {
        style: _normalizeStyle({ opacity: showTooltip.value ? 1 : 0, visibility: showTooltip.value ? 'visible' : 'hidden' }),
        toolTipText: _ctx.$t('_toolTip.effectDisabledToolTipText'),
        disableTooltip: __props.disableSilenceApply || silenceValue.value == '0ms',
        toolTipType: "applybtn"
      }, null, 8, ["style", "toolTipText", "disableTooltip"])
    ])
  ]))
}
}

})